// 散布圖配置
export const scatterChartConfig = {
	// 散布圖基本設置
	basic: {
		type: "scatter",
		symbolSize: 8,
	},
	
	// 強調效果
	emphasis: {
		itemStyle: {
			borderWidth: 2,
			shadowBlur: 10,
			shadowColor: "rgba(0, 0, 0, 0.08)",
		},
	},
	
	// 工具提示設置
	tooltip: {
		show: true,
        trigger: "item",
		formatter: function (params, sourceData, ageRangeColor) {
			// 這裡會由外部傳入的 formatter 函數處理
			return params.formatter ? params.formatter(params, sourceData, ageRangeColor) : "";
		},
	},
	
	// 樣式設置
	itemStyle: {
		borderWidth: 1,
	},
	
	// 軸線設置
	axis: {
		xAxis: {
			type: "value",
			name: "", // 進步值
			nameLocation: "middle",
			nameGap: 50,
			splitNumber: 10, // 分割數量
			splitLine: {
				show: true,
				lineStyle: {
					color: "#f0f0f0",
				},
			},
		},
		yAxis: {
			type: "value",
			inverse: true, // 反向
			name: "", // 名次
			nameLocation: "middle",
			nameGap: 50,
			min: 1, // 第一名
			splitLine: {
				show: true,
				lineStyle: {
					color: "#f0f0f0",
				},
			},
		},
	},
	
	// 網格設置
	grid: [
		{
			left: "3%",
			right: "4%",
			top: "60%",
			bottom: "3%",
			containLabel: true,
		},
	],
	
	// 單位
	unitMap: {
		type1: "KG",
		type2: "KG",
		type3: "%",
		type4: "KG",
		type5: "CM",
	},
	
	// 軸標籤格式化
	axisLabelFormatters: {
		xAxis: (value, type) => `${value} ${scatterChartConfig.unitMap[type] || ""}`,
		yAxis: (value) => `第${value}名`,
	},
};
